'use strict';

const headerImg = document.querySelector('header.header-img figure');

if (headerImg) {
    window.addEventListener('load', () => {
        headerImg.classList.add('animate');
    });
}
